// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable no-new */
import Vue from 'vue'
window.Vue = Vue

// APp
import App from './App'
//router
import router from './router'

// material
import 'material-design-icons-iconfont/dist/material-design-icons.css';
// roboto
import 'roboto-fontface/css/roboto/roboto-fontface.css';

//lodash
import _ from 'lodash';
// lodashのグローバルオブジェクト登録
window._ = _

//vuetify
import vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
Vue.use(vuetify, {
    theme: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
    }
})

//trend
import Trend from 'vuetrend';
Vue.use(Trend);

//color
import colors from "vuetify/es5/util/colors";
Vue.use(colors);

//echarts
import 'echarts'
import 'echarts/map/js/china'
import 'echarts/map/js/world'
import 'echarts-gl'
//vue-echarts
import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack
Vue.component('vue-chart', ECharts)

//vue-i18n
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import locale from './utility/Locale';
let data = null;
let lang = '';

if (locale.getCurrentLanguage() === 'ja') {
    data = require('./i18n/message.ja.json');
    lang = 'ja';
} else if (locale.getCurrentLanguage() === 'en' || locale.getCurrentLanguage() === 'en-US') {
    data = require('./i18n/message.en.json');
    lang = 'en';
} else {
    data = require('./i18n/message.ch.json');
    lang = 'ch';
}

const i18n = new VueI18n({
    locale: lang,
    messages: data
});

// SweetAlert
import VueSwal from 'vue-swal'
Vue.use(VueSwal)

// Ajax通信ライブラリ
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios)

// Vueオブジェクトに全コンポーネントをミックイン(取り込む)
import * as components from './components/index'
Vue.mixin({
    components
})

import core from './core/Main'
Vue.use(core)
// サイドメニューの表示項目を登録
let routes = core.routes

routes[0].list.forEach((route, index, array) => {
    route.name = i18n.t(`${route.name}.Item`)
});

// ヘッダーへの画面名の表示登録
router.afterEach((to, from) => {
    //console.log(to.path.split('/'));
    let [n, a, b] = to.path.split('/') // n:"" a:"dashboard" b:"dashboard2"
    let r = core
    r.appConfig.level1 = a || ''
    r.appConfig.level2 = b || ''
    r.appConfig.title1 = routes.find(x => x.id == r.appConfig.level1)
    r.appConfig.title1 = r.appConfig.title1 || {}
    r.appConfig.title1.name = r.appConfig.title1.name || 'Dashboard1'
    r.appConfig.title2 = r.appConfig.title1.list ? r.appConfig.title1.list.find(x => x.id == r.appConfig.level2) : r.appConfig.title1;
    r.appConfig.title2 = r.appConfig.title2 || r.appConfig.title1
})

Vue.config.productionTip = false

let url = '';
if(process.env.NODE_ENV === 'development') {
    url = 'http://localhost:5001';
} else {
    url = window.location.origin;
}

new Vue({
    el: '#app',
    router,
    i18n: i18n,
    data() {
        return {
            url: url,
            login: {
                user: '',
                type: '',
                assign: '',
                token: ''
            },
            currentTimer: null
        }
    },
    template: '<App/>',
    components: {
        App
    }
})



// WEBPACK FOOTER //
// ./src/main.js